<template>
  <div class="leaders-company-details">
    <common-link
      v-if="logoSrc"
      :href="profileHref"
      title="View Company Profile"
      class="leaders-company-details__logo"
      @click="emitProfileClick('Company Logo', ...arguments)"
    >
      <!-- @todo update this to properly lazyload! -->
      <img
        class="lazyload"
        :src="logoSrc"
        :alt="logoAlt"
      >
    </common-link>

    <div class="leaders-company-details__links">
      <button-link
        v-if="companyHref"
        :href="companyHref"
        :block="true"
        target="_blank"
        type="accent"
        @click="emitWebsiteClick"
      >
        {{ translate("visitSiteLabel") }}
      </button-link>
      <button-link
        :href="profileHref"
        :block="true"
        @click="emitProfileClick('View Profile Button', ...arguments)"
      >
        {{ translate("viewProfileLabel") }}
      </button-link>
      <button-link
        v-if="boothButtonText && boothUrl"
        :href="boothUrl"
        :block="true"
        target="_blank"
      >
        <div class="row">
          <div class="col-8" v-html="boothButtonText" />
          <div class="col-4">
            <img
              v-if="boothShowIcon"
              :src="boothShowIcon"
              width="25"
              height="25"
            >
          </div>
        </div>
      </button-link>
    </div>
  </div>
</template>

<script>
import i18n from '../../../utils/i18n-vue';
import ButtonLink from '../../common/button-link.vue';
import CommonLink from '../../common/link.vue';

const { log } = console;

const query = ({ salesforceAccountId, boothShowId }) => `
  query {
    company: companyById(input: { id: "${salesforceAccountId}" }) {
      _id
      booths(input: { showId: "${boothShowId}" }) {
        id
        accountId
        boothNumber
      }
    }
  }
`;

export default {
  components: { ButtonLink, CommonLink },

  props: {
    companyName: {
      type: String,
      required: true,
    },
    profileHref: {
      type: String,
      required: true,
    },
    companyHref: {
      type: String,
      default: null,
    },
    lang: {
      type: String,
      default: 'en',
    },
    logoSrc: {
      type: String,
      default: null,
    },
    salesforceAccountId: {
      type: String,
      default: null,
    },
    boothShowIcon: {
      type: String,
      default: '',
    },
    boothShowId: {
      type: String,
      default: '',
    },
    boothShowUrl: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    booths: null,
  }),

  computed: {
    logoAlt() {
      return `${this.companyName} Logo`;
    },
    boothUrl() {
      if (this.boothShowUrl && this.booths && this.booths.length) {
        return `${this.boothShowUrl}${this.booths[0].accountId}`;
      }
      return '';
    },
    boothButtonText() {
      if (this.booths && this.booths.length) {
        const boothSplit = this.booths[0].boothNumber.split(',');
        if (boothSplit.length === 1) {
          return `See Us At ${boothSplit[0]}`;
        }
        if (boothSplit.length > 1) {
          return `See us at ${boothSplit[0]} <br> and more.`;
        }
      }
      return '';
    },
  },

  async mounted() {
    if (this.salesforceAccountId && this.boothShowId) {
      const { salesforceAccountId, boothShowId } = this;
      const response = await fetch('https://www.prosource.org/graphql', {
        body: JSON.stringify({ query: query({ salesforceAccountId, boothShowId }) }),
        headers: { 'content-type': 'application/json' },
        method: 'POST',
      });
      const jsonResponse = await response.json();
      if (!response.ok) {
        log('Unsuccessful external API response!', jsonResponse);
      }
      this.booths = jsonResponse.data.company.booths;
    }
  },

  methods: {
    emitWebsiteClick(...args) {
      this.$emit('website-click', ...args);
    },
    emitProfileClick(sourceLabel, data, event) {
      this.$emit('profile-click', { sourceLabel, ...data }, event);
    },
    translate(key) {
      return i18n(this.lang, key);
    },
  },
};
</script>
